import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './ApprovalSubHeader.messages';
import styles from './ApprovalSubHeader.module.css';
import { useIsInSelfServeSplitTest } from '../../../../../customHooks/useIsInSelfServeSplitTest';
import IwMedia from '../../../../../iwMedia/IwMedia';
import { MultipleUsersSVG } from '../../../../../svgComponents/multipleUsersSVG/MultipleUsersSVG';
import { PaymentCardSVG } from '../../../../../svgComponents/paymentCardSVG/PaymentCardSVG';
import { RocketSVG } from '../../../../../svgComponents/rocketSVG/RocketSVG';

const ApprovalSubHeader = () => {
    const isInSelfServeSplitTest = useIsInSelfServeSplitTest();
    return (
        <IwMedia from="medium">
            <div
                className={styles.subHeader}
                data-testid="loan-builder-subheader"
            >
                <ul
                    className={classNames(
                        styles.row,
                        isInSelfServeSplitTest && styles.selfServeSplitTest
                    )}
                >
                    {!isInSelfServeSplitTest && (
                        <li className={styles.lineItem}>
                            <MultipleUsersSVG
                                className={styles.multipleUsersSVG}
                            />
                            <FormattedMessage {...messages.subheaderOne} />
                        </li>
                    )}
                    <li className={styles.lineItem}>
                        <RocketSVG className={styles.rocketSVG} />
                        <FormattedMessage {...messages.subheaderTwo} />
                    </li>
                    <li className={styles.lineItem}>
                        <PaymentCardSVG className={styles.paymentSVG} />
                        <FormattedMessage {...messages.subheaderThree} />
                    </li>
                </ul>
            </div>
        </IwMedia>
    );
};

// eslint-disable-next-line import/no-default-export
export default ApprovalSubHeader;
